module.exports = __webpack_public_path__ + "static/media/staff_trish.19ae8840.svg";